/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Eventreport_Example_Item21Inputs */

const ja_playdata_eventreport_example_item21 = /** @type {(inputs: Playdata_Eventreport_Example_Item21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同時視聴者数の推移`)
};

const en_playdata_eventreport_example_item21 = /** @type {(inputs: Playdata_Eventreport_Example_Item21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track viewers over time`)
};

/**
* | output |
* | --- |
* | "Track viewers over time" |
*
* @param {Playdata_Eventreport_Example_Item21Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const playdata_eventreport_example_item21 = /** @type {((inputs?: Playdata_Eventreport_Example_Item21Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Eventreport_Example_Item21Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_eventreport_example_item21(inputs)
	return en_playdata_eventreport_example_item21(inputs)
});
export { playdata_eventreport_example_item21 as "playdata_eventReport_example_item2" }